/**
 * @class ReactChipInput (inspired from this and edited https://github.com/shhdharmen/react-chip-input)
 */

import { useEffect, useState, useRef } from 'react';
import { ReactComponent as CloseIcon } from './baseline-close-24px.svg';
import styles from './styles.module.css';

const ReactChipInput = (props) => {
  const {
    /**Emits index */
    onRemove,
    /**Array of chips */
    chips,
    /**Extra classes */
    classes,
    /**Emits value */
    onSubmit,
  } = props;
  
  const formControlRef = useRef(null);
  const [state, setState] = useState({ 
        focused: false, 
        exitingIndex: -1 
      });

  /**Called when user clicks on remove icon.
   * And in turn, onRemove of props called, wih index passed as argument.
   */
  const removeChip = (index) => {
    console.log("Removing chip ", index);
    const editChipValue = chips[index];
    setState({ exitingIndex: index });
    
    setTimeout(() => {
      props?.onRemove(editChipValue, index);
      setState({ exitingIndex: null });
    }, 250);
  };

  /**When user double clicks on any chip, it will start editing. */
  const editChip = (index) => {
    const chips = props?.chips.slice();
    const editChipValue = chips[index];
    chips.splice(index, 1);
    setState({ chips });

    props?.onRemove(editChipValue, index);
    formControlRef.current.value = editChipValue;
    formControlRef.current.focus();
  };

  // useEffect(() => {
  //   // if (prevProps.chips.length !== props?.chips.length) {
  //   //        formControlRef.current.value = '';
  //   //     }
  
  //   // return () => {
  //   //   second
  //   // }
  // }, [chips])

  const main_css = [
        props?.classes,
        styles.chipInput,
        'rounded',
        state?.focused ? styles.shadowPrimary : 'border'
      ].join(' ');
  //const chip_css = styles.chip;
  const chipEntry_css = ['m-0', 'border-0', styles['no-focus'], 'mb-0'].join(' ');
  const delete_css = 'ml-2 ' + styles.cursorPointer + " " + styles.chipDelete;

  const isChipHidden = (index) => {
    return state?.exitingIndex === index ? styles.hide : styles.show 
  };
      
      return (
      /**The main container div */
      <div className={main_css}>
          <div class="container">
            <div class="row">
          {props?.chips.map((chip, index) => (
             
            //  <div class="d-inline-flex p-2" key={index}>
                <div
                  key={index}
                  className={styles.chip + " d-inline-flex " + isChipHidden(index) }
                  onDoubleClick={() => editChip(index)}
                >
                  <span className={styles.chipText}>{chip}</span>
                  {/* The icon which helps user, if user wants to remove the chip */}
                  <CloseIcon
                    className={delete_css} 
                    onClick={() => removeChip(index)}
                  />
                </div>
            //  </div>
          ))}
          
          <div class="col-12">
            {/* The input, from which value is read and chip is added accordingly */}
            <form
              className="custom-form-control"
              onSubmit={(e) => {
                  e.preventDefault();
                  props?.onSubmit(formControlRef.current.value);
              }}
              noValidate
              >
              <input
                ref={formControlRef}
                name="chipInput"
                placeholder="Enter Here..."
                aria-label="Chip Input"
                className={chipEntry_css}
                onFocus={() => setState({ focused: true })}
                //onBlur={() => setState({ focused: false })}
                />
            </form>
            </div>
            </div>
          </div>
      </div>
    );
};

export default ReactChipInput;
